export default __webpack_public_path__ + "static/media/Fabian-euq.785b966b.png";